<template>
    <div class="paper-admin">
        <el-scrollbar class="resources-scroll">
            <div class="paper-admin-header">
                <div class="header-select">
                    试卷分类
                    <el-cascader v-model="paperGradeValue" style="width: 250px;margin-left: 12px" :props="keyObj"
                                 :options="paperGradeList"
                                 @change="selectPaper" placeholder="请选择试卷分类"></el-cascader>
                </div>
                <el-input placeholder="请输入试卷名称" style="width: 250px;" v-model="searchValue"
                          @change="getPaperList"></el-input>
            </div>
            <div class="table-wrapper">
                <!--自己写的表格-->
                <div class="d-table">
                    <div class="d-thead">
                        <div class="d-tr">
                            <div class="d-th">
                                <div class="cell">试卷名称</div>
                            </div>
                            <div class="d-th-200">
                                <div class="cell">试卷分类</div>
                            </div>
                            <div class="d-th-200">
                                <div class="cell">分值</div>
                            </div>
                            <div class="d-th-100">
                                <div class="cell">操作</div>
                            </div>
                        </div>
                    </div>
                    <div class="d-tbody">
                        <el-scrollbar style="height: 100%">
                            <draggable :list="paperList" :group="{name: 'resources', pull: 'clone', put: false }"
                                       :sort="false" :move="onMove" @end="onEnd">
                                <div class="d-tr" v-for="(item, index) in paperList" :key="index">
                                    <div class="d-td">
                                        <div class="cell" v-if="mode === '0'">
                                            <el-checkbox v-model="checkedList" :label="item.theory_test_paper_id"
                                                         :disabled="!curIndex">{{item.name}}
                                            </el-checkbox>
                                        </div>
                                        <div class="cell 123" v-else>{{item.name}}</div>
                                    </div>
                                    <div class="d-td-200 resourceTit">
                                        <div class="cell">{{item.category_name}}</div>
                                    </div>
                                    <div class="d-td-200">
                                        <div class="cell">{{item.total_score?item.total_score:item.score}}</div>
                                    </div>
                                    <div class="d-td-100 d-td-right">
                                        <el-link type="primary">预览</el-link>
                                    </div>

                                </div>
                            </draggable>
                        </el-scrollbar>
                    </div>
                </div>
                <div class="exampaper-import" v-if="mode === '0' && curIndex">
                    <el-button type="primary" size="small" @click="selectExamPaper">一键添加</el-button>
                </div>
            </div>
            <el-pagination class="pager-center"
                           :current-page="paperPages.currentPageNum"
                           :page-size="paperPages.eachPageNum"
                           :total="paperPages.total"
                           layout="prev, pager, next, jumper"
                           @current-change="paperCurrentChange">
            </el-pagination>
        </el-scrollbar>
    </div>
</template>

<script>
    import {theoryTestPaperGetList, theoryTestPaperGetNameByCategory, catePage} from '@/utils/apis';
    import draggable from 'vuedraggable';
    import _ from 'underscore';

    export default {
        name: "MaterialExam",
        props: ['mode', 'curIndex', 'child'],
        components: {
            draggable
        },
        data() {
            return {
                searchValue: '',
                paperList: [],
                paperPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
                checkedList: [],
                paperGradeValue: '',
                paperGradeList: [],
                keyObj: {
                    label: 'name',
                    value: 'id',
                    children: 'children'
                },
            }
        },
        watch: {
            searchValue(d) {
                this.sendAjax();
            }
        },
        mounted() {
            this.getPaperList();
            this.getTypeList();
        },
        methods: {
            //防抖
            sendAjax: _.debounce(function () {
                this.getPaperList();
            }, 1000),
            initCheckeds() {
                this.checkedList = [];
            },
            selectPaper() {
                this.getPaperList();
            },
            getTypeList() {
                let params = {
                    type: 3
                }
                catePage(params).then((res) => {
                    this.paperGradeList = res.data.list;
                }).catch((err) => {
                    console.log('err', err)
                })
            },
            getPaperList() {
                let params = {
                    paging: 1,
                    page: this.paperPages.currentPageNum,
                    pageSize: this.paperPages.eachPageNum
                }
                if (this.searchValue) {
                    params.like = this.searchValue
                }
                if (this.paperGradeValue.length) {
                    params.category_id = this.paperGradeValue[this.paperGradeValue.length - 1];

                    theoryTestPaperGetNameByCategory(params).then((res) => {
                        this.paperList = _.map(res.data, (item) => {
                            item.material_type = 2
                            item.name = item.theory_test_paper_name
                            item.resource_id = item.theory_test_paper_id
                            item.id = item.theory_test_paper_id
                            item.type = 2
                            item.child = [];
                            return item;
                        });
                        this.paperPages.total = res.data.total;
                    }).catch((err) => {
                        console.log('err', err)
                    })
                } else {
                    theoryTestPaperGetList(params).then((res) => {
                        this.paperList = _.map(res.data.list, (item) => {
                            item.material_type = 2
                            item.resource_id = item.theory_test_paper_id
                            item.id = item.theory_test_paper_id
                            item.type = 2
                            item.child = [];
                            return item;
                        });
                        this.paperPages.total = res.data.total;
                    }).catch((err) => {
                        console.log('err', err)
                    })
                }
            },
            paperCurrentChange(val) {
                this.paperPages.currentPageNum = val;
                this.getPaperList();
            },
            selectExamPaper() {
                let arrTmp = _.filter(this.paperList, (item) => {
                    return this.checkedList.indexOf(item.theory_test_paper_id) !== -1;
                });
                arrTmp = _.map(arrTmp, (item) => {
                    let obj = {};
                    obj.name = item.name;
                    obj.id = item.theory_test_paper_id;
                    obj.child = [];
                    obj.type = 2;
                    return obj
                })
                let arr = [];
                let len = arrTmp.length;
                arrTmp.forEach((item, index) => {
                    arr.push(this.format(item));
                })
                for (let i = len; i >= 0; i--) {
                    if (arr[i] == false) {
                        arrTmp.splice(i, 1)
                    }
                }
                this.$emit('reexampapers', arrTmp);
                this.initCheckeds();
            },
            onMove(evt) {
                let obj = evt.draggedContext.element;
                let result = this.format(obj);
                return result
            },
            format(obj) {
                let result = true;
                this.child.forEach((ele) => {
                    if (ele.child.length) {
                        ele.child.forEach((sec) => {
                            if (sec.child.length) {
                                sec.child.forEach((resource) => {
                                    if (resource != null) {
                                        if (resource.type == obj.type && resource.id == obj.id) {
                                            result = false
                                        }
                                    }
                                })
                            }
                        })
                    }
                });
                return result
            },
            onEnd(evt) {

            }
        }
    }
</script>

<style scoped lang="scss">
    .paper-admin {
        box-sizing: border-box;
        height: 100%;
        display: flex;
        flex-direction: column;

        .resources-scroll {
            height: 100%;

            ::v-deep .el-scrollbar__view {
                padding: 0 20px;
            }
        }

        .paper-admin-header {
            display: flex;
            justify-content: space-between;

            ::v-deep .el-input {
                .el-input-group__append {
                    padding-right: 10px;
                    box-sizing: border-box;
                    height: 40px;
                    //background: #F23B2F;
                    color: #fff;
                    font-size: 16px;

                    .el-button {
                        height: 40px;
                        border-radius: 0 4px 4px 0;
                        padding: 0 8px;
                        background: #F23B2F;

                        &:hover {
                            background: #F23B2F;
                        }
                    }
                }
            }
        }

        .table-wrapper {
            position: relative;
            margin-top: 20px;

            .table-content {
                .img-thumb {
                    width: 60px;
                    height: 60px;
                    overflow: hidden;

                    img {
                        display: block;
                        max-width: 100%;
                        max-height: 100%;
                    }
                }
            }

            .d-table {
                width: 100%;
                border: 1px solid #EBEEF5;
                position: relative;
                overflow: hidden;
                box-sizing: border-box;
                flex: 1;
                max-width: 100%;
                font-size: 14px;
                color: #606266;
                background-color: #FFF;

                .d-tbody {
                    height: 497px;

                    ::v-deep .el-scrollbar__view {
                        padding: 0;
                    }
                }

                .d-tr {
                    height: 53px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    cursor: move;

                    .d-th, .d-th-80, .d-th-100, .d-th-200 {
                        background-color: rgb(245, 247, 250);
                    }

                    .d-th-80, .d-th-100, .d-th-200, .d-td-80, .d-td-100, .d-td-200, .d-th, .d-td {
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-bottom: 1px solid #EBEEF5;
                    }

                    .d-th, .d-td {
                        flex: 1;
                        justify-content: flex-start;
                        padding: 0 10px;
                        align-items: center;
                    }

                    .d-th-80, .d-td-80 {
                        width: 80px;
                    }

                    .d-th-100, .d-td-100 {
                        width: 100px;
                    }

                    .d-th-200, .d-td-200 {
                        width: 200px;
                    }

                    .d-td-right {
                        border-right: none;
                    }
                }
            }

            .one-import {
                position: absolute;
                bottom: 5px;
                left: 10px;
            }
        }

        .table-wrapper table {
            width: 100%;
            max-height: 500px;
            border: 1px solid #EBEEF5;
            border-right: none;
            border-bottom: none;
            position: relative;
            overflow: hidden;
            box-sizing: border-box;
            flex: 1;
            max-width: 100%;
            font-size: 14px;
            color: #606266;
            background-color: #FFF;
            border-spacing: 0;

            thead {
                color: #909399;
                font-weight: 500;

                tr {
                    background-color: #FFF;
                    height: 44px;

                    th {
                        border-bottom: 1px solid #EBEEF5;
                        font-weight: normal;
                        color: rgb(51, 51, 51);
                        background: rgb(245, 247, 250);
                        border-right: 1px solid #EBEEF5;
                    }
                }
            }

            tbody {
                tr {
                    height: 53px;

                    td {
                        border-bottom: 1px solid #EBEEF5;
                        border-right: 1px solid #EBEEF5;
                        text-align: center;
                    }
                }
            }
        }

        .pager-center {
            padding: 20px 0;
            text-align: center;
        }
    }
</style>